
export class TokenGroupCtrl {
  constructor($scope, $compile, $timeout, DomService, TemplateService, EventService, FlashService) {
    'ngInject';
    this.$scope = $scope;
    this.$compile = $compile;
    this.$timeout = $timeout;
    this.ds = DomService;
    this.fs = FlashService;

    this.resizeBorderWidth = 5;
    this.initialized = false;
    this.ts = TemplateService;
    this.es = EventService;
    this.collisonTokens = [];
    this.$tokenGroupDivs = [];
  }

  $onInit() {
    const wPage = this.$scope.$watch('$ctrl.page', () => {
      this.initialized && this.initializeHelpers();
    });
    this.$scope.$on('$destroy', () => { wPage() });

    this.es.subscribeEvent(
      this.es.actions.TOKEN_GROUP_STYLE_SET, 
      (data) => { 
        if(this.page.id == data.activePageId){
          this.updateSelector(data.selectedTokens);
        }
      },
      `TOKEN_GROUP_STYLE_SET_${this.page.id}`);
    
  }

  initializeCollisionDetection() {
    this.collisonTokens = this.ts.template.tokens.filter(t => !t._selected);
  }

  initializeHelpers() {
    this.$tokenGroup = $(`#token-group-${this.page.id}`);
    this.$tokenGroupSize = $(`#token-group-size-${this.page.id}`);
    this.$tokenGroupSelected = $(`#token-group-selected-${this.page.id}`);
    this.$page = $(`#page-preview-window-${this.page.id}`);
    this.initialized = true;
  }

  updateSelectorSize($ui, resize) {
    let left, top, width, height;
    if(resize) {
      const position = $ui.position;
      const size = $ui.size;
      top = position.top + this.resizeBorderWidth;
      left = position.left + this.resizeBorderWidth;
      width = size.width - this.resizeBorderWidth * 2;
      height = size.height - this.resizeBorderWidth * 2;
    }
    else {
      const $selector = $($ui.helper[0]);
      const position = $selector.position();
      top = position.top;
      left = position.left;
      width = $selector.width();
      height = $selector.height();
    }

    this.$timeout(() => { 
      this.selectorDimensions = { top, left, right: left + width, bottom: top + height };
      this.checkCollisions();
    });
  }

  getTokenOptions() {
    return {
      snap: '.snap-target',
      snapTolerance: 8,
      containment: ".designer"
    };
  }

  tokensDrag($event, $ui) {
    this.updateSelectorSize($ui, false);
    $event.stopPropagation();
  }

  tokensDragEnd(event, ui, adjustPage) {
    if (this.checkTokenCollision()) this.cancelTokenTransform();
    else this.onTokensDragEnd({event, ui, adjustPage});
  }

  tokensResizeEnd(event, ui) {
    if (this.checkTokenCollision()) this.cancelTokenTransform();
    else this.onTokensResizeEnd({event, ui});
  }

  cancelTokenTransform() {
    this.ts.template.tokens.forEach(t => t._colliding = false);
    this.updateSelector(this.ts.template.tokens.filter(t => t._selected));
  }

  checkTokenCollision() {
    let collided = false;
    if (this.collisonTokens.some(t => t._colliding && !t.options?.snappedToField)) {
      this.fs.error("Overlapping fields detected, please try again.");
      collided = true;
    }
    return collided;
  }

  updateSelector(selectedTokens) {

    this.initialized || this.initializeHelpers();
    const dummyTokens = {};
    const tokens = selectedTokens;
    let box ={
      top: Number.MAX_VALUE, 
      left: Number.MAX_VALUE, 
      right: 0, 
      bottom: 0
    };

    // Selected tokens box
    tokens.forEach(t => {
      const $t = this.ds.getJqToken(t);
      const s = this.ds.getJqCssVals($t, ['top', 'left', 'width', 'height']);
      const p = $t.offset();
      dummyTokens[t.id] = { top: p.top, left: p.left, height: s.height, width: s.width };
      box.top = Math.min(box.top, p.top);
      box.left = Math.min(box.left, p.left);
      box.right = Math.max(box.right, p.left + s.width);
      box.bottom = Math.max(box.bottom, p.top + s.height);

    });

    if (tokens.length > 0) {
      const base = this.$page.offset();
      const page = { width: this.$page.width(), height: this.$page.height() };

      box.left -= base.left;
      box.right -= base.left;
      box.top -= base.top;
      box.bottom -= base.top;
      box.width = box.right - box.left;
      box.height = box.bottom - box.top;
      let proportions = {};

      this.$tokenGroupSize.css({
        'left': box.left - this.resizeBorderWidth,
        'top': box.top - this.resizeBorderWidth,
        'width': box.width + (this.resizeBorderWidth * 2),
        'height': box.height + (this.resizeBorderWidth * 2)
      });

      this.$tokenGroupSelected.css({
        'left': box.left,
        'top': box.top,
        'width': box.width,
        'height': box.height
      });

      this.$tokenGroupSelected.empty();

      tokens.forEach((t, i) => {
        const id = t.id;
        const $child = $(`
          <div 
          id="${id}"
          class="token-group-drag"
          ng-rightclick="$ctrl.onTokenRightClick({id: '${t.id}', event: $event})"
          ng-dblclick="$ctrl.onTokenDoubleClick({id: '${t.id}', event: $event})"
          ng-click="$ctrl.onSelectedTokenClick({index: ${i}, event: $event})"></div>`);
        proportions[id] = {
          'top': (dummyTokens[t.id].top - base.top - box.top),
          'left': (dummyTokens[t.id].left - base.left - box.left),
          'width': (dummyTokens[t.id].width),
          'height': (dummyTokens[t.id].height)
        };
        $child.css({
          'top': proportions[id].top + 'px',
          'left': proportions[id].left + 'px',
          'width': proportions[id].width + 'px',
          'height': proportions[id].height + 'px'
        });
        proportions[id].dWidth = (proportions[id].left / box.width);
        proportions[id].dHeight = (proportions[id].top / box.height);
        this.$tokenGroupSelected.append(this.$compile($child)(this.$scope));
      });
      this.$tokenGroup.show();
      this.$tokenGroupSize
        .draggable({ snap: '.snap-target' })
        .resizable({
          snap: '.snap-target', 
          borderWidth: this.resizeBorderWidth,
          snapTolerance: 8,
          'handles': 'n, s, e, w',
          start: (event, ui) => {
            const axis = this.$tokenGroupSize.data('ui-resizable').axis;
            let maxWidth = page.width + (this.resizeBorderWidth * 2), maxHeight = page.height + (this.resizeBorderWidth * 2);
            switch (axis) {
              case 'e':
                maxWidth -= box.left;
                break;
              case 'w':
                maxWidth = box.left + box.width + (this.resizeBorderWidth * 2);
                break;
              case 'n':
                maxHeight = box.top + box.height + (this.resizeBorderWidth * 2);
                break;
              case 's':
                maxHeight -= box.top;
                break;
            }
            this.$tokenGroupSize.resizable("option", "maxWidth", maxWidth);
            this.$tokenGroupSize.resizable("option", "maxHeight", maxHeight);
          },
          stop: (event, ui) => {
            this.tokensResizeEnd(event, ui);
          },
          resize: (e, ui) => {
            const dW = ((ui.size.width - this.resizeBorderWidth * 2) / box.width);
            const dH = ((ui.size.height - this.resizeBorderWidth * 2) / box.height);
            const oLeft = ui.position.left - box.left + this.resizeBorderWidth;
            const oTop = ui.position.top - box.top + this.resizeBorderWidth;

            this.$tokenGroupSelected.find("*").each((i, elm) => {
              const $elm = $(elm);
              const id = $elm.attr('id');
              $elm.css({
                "width": dW * proportions[id].width,
                "height": dH * proportions[id].height,
                "left": (proportions[id].left + oLeft) + (proportions[id].dWidth * ((ui.size.width - this.resizeBorderWidth * 2) - box.width)),
                "top": (proportions[id].top + oTop) + proportions[id].dHeight * ((ui.size.height - this.resizeBorderWidth * 2) - box.height)
              });
            });

            this.updateSelectorSize(ui, true);
          }
        });
      this.$tokenGroupDivs = Array.from($('.token-group-drag'));
    }
    else {
      // Hide all selectors
      $('.token-group').hide();
    }
    this.initializeCollisionDetection();
  }

  checkCollisions() {
    this.collisonTokens.forEach(t => {
      const $t = $(`#token-${t.id}.token-container`)[0];
      const collides = this.$tokenGroupDivs.some($g => this.isColliding($g, $t));
      t._colliding = collides && !t.options?.snappedToField;
    });
  }

  isColliding(el1, el2) {
    const rect1 = el1.getBoundingClientRect();
    const rect2 = el2.getBoundingClientRect();
    const tolerancePx = 2;
  
    return !(
      rect1.top + rect1.height - tolerancePx <= rect2.top ||
      rect1.top + tolerancePx >= rect2.top + rect2.height ||
      rect1.left + rect1.width - tolerancePx <= rect2.left ||
      rect1.left + tolerancePx >= rect2.left + rect2.width
    );
  }

  selectedGroupClick(event) {
    event.stopPropagation();
  }

  selectedGroupDoubleClick(event) {
    event.stopPropagation();
    this.onTokenDoubleClick({id: null, event});
  }
}

export default {
  bindings: {
    page: "=",
    selectorDimensions: "=",
    onSelectedTokenClick: "&",
    onTokenRightClick: "&",
    onTokenDoubleClick: "&",
    onTokensDragEnd: "&",
    onTokensResizeEnd: "&"
  },
  controller: TokenGroupCtrl,
  templateUrl: 'form-builder/token-group/token-group.component.html',
}
